<c-sidebar visible #sidebar1="cSidebar" class="border-end" id="sidebar1" visible>
  <c-sidebar-header class="border-bottom">
    <c-sidebar-brand [routerLink]="['/']">
      <img src="/assets/logos/datalivelogo.png" width="170" />
    </c-sidebar-brand>

    <app-dl-module-selector></app-dl-module-selector>

  </c-sidebar-header>
  <h5 class="c-sidebar-module-name">Vehicle Utilisation</h5>
  <c-sidebar-nav [navItems]="navItems" />
  <c-sidebar-footer cSidebarToggle="sidebar1" class="border-top" toggle="unfoldable" style="cursor: pointer;">
    <button cSidebarToggler></button>
  </c-sidebar-footer>
</c-sidebar>

<div class="wrapper d-flex flex-column min-vh-100">
  <app-dynamic-header></app-dynamic-header>
  <div class=" flex-grow-1">
    <c-container breakpoint="lg" class="h-auto">
      <router-outlet />
    </c-container>
  </div>
  <app-default-footer />
</div>
